import { nl } from 'date-fns/locale';
const dateNlNL = {
  name: 'nl-NL',
  locale: nl
};
export default dateNlNL;